/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SensorReadingDTO { 
    logicalName?: string;
    variableName?: string;
    value?: string;
    unit?: string;
}

